<main role="main" id="content" class="grid tos">
  <section class="grid-sitewidth balance-pad">
    <h1>Terms & Conditions of Use</h1>
    <app-terms-and-conditions-content />

  </section>

</main>
